import classnames from 'classnames'
import React from 'react'
import s from './ScrollList.less'

const ScrollList = ({ data, render, listRef, listItemsRefs, listClassName, listItemClassName, selectedItem }) => (
  <ul ref={listRef} className={listClassName}>
    {data.map((dataItem, idx) => {
      const isSelected = selectedItem && selectedItem.id === dataItem.id
      return (
        <li
          ref={listItemsRefs?.[idx]}
          key={`${dataItem.id}-${idx}`}
          className={classnames(listItemClassName, selectedItem && !isSelected && s.itemInactive)}
        >
          {render(dataItem)}
        </li>
      )
    })}
  </ul>
)

export default ScrollList
